import script from "./dummyData7.vue?vue&type=script&lang=js"
export * from "./dummyData7.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__